import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { downloadFile, translate, getUserNameToName, formatDateToPtbr } from '../../../../utils/util';
import ContainerService from '../../../../services/ContainerService';
import ConfirmModal from '../../../../components/UI/ConfirmModal';
import { Breadcrumbs, Input, Button, Collapsible, Table, CustomNumberInput } from '../../../../components/UI/ComponentsUI'
import { onValueChange, onValueChangeByValue } from '../../../../utils/handleChangeHooks';
import * as containerAction from '../../../../actions/containerAction';
import { checkPermission } from '../../../../services/auth';
import { PERMISSIONS } from '../../../../utils/constants';

const Mdr = (props) => {
    const messageModal = useRef();
    const [currentPage, setCurrentPage] = useState({ pageSize: 20, pageIndex: 0, sortField: "", sortOrder: 0 });
    const [mdrList, setMdrList] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [selectedItem, setSelectedItem] = useState(undefined);
    const [filter, setFilter] = useState({ internal: false });
    const [deleteAllSelected, setDeleteAllSelected] = useState(false);

    useEffect(() => {
        search();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (props.mdrList?.items?.length > 0) {
            setMdrList([...props.mdrList.items]);
        } else {
            setMdrList([]);
        }
        // eslint-disable-next-line
    }, [props?.mdrList]);

    const search = () => {
        props.getMdrPaged(filter);
    }

    const openModal = (item) => {
        setSelectedItem(item)
        messageModal.current.show();
    }

    const deleteSelectedItem = () => {
        props.deleteItem(selectedItem, () => {
            messageModal.current.close();
            setSelectedItem(undefined);
            search();
        });
    };

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const onChangeItem = (event) => {
        onValueChange(event, selectedItem, setSelectedItem);
        if (selectedItem.height && selectedItem.width && selectedItem.length) {
            selectedItem.volume = (selectedItem.height * selectedItem.width * selectedItem.length) / 1000;
            setSelectedItem({ ...selectedItem });
        }
    };

    const onChangeItemWeight = (event) => {
        selectedItem.weight = parseFloat(event.target.value.replace(",", "."));
        setSelectedItem({ ...selectedItem })
    };

    const onSelectChange = (item) => {
        setSelectedItem(item);
    }

    const removeSelected = (item) => {
        let list = [];
        Object.assign(list, selectedItems);
        let index = list.findIndex(x => x.id === item.id);
        list.splice(index, 1);
        setSelectedItems(list)
    }

    const onCheckedChange = (item) => {
        if (selectedItems.some(e => e.id === item.id)) {
            removeSelected(item)
        } else {
            let list = [];
            Object.assign(list, selectedItems);
            list.push(item)
            setSelectedItems(list);
        }
    }

    const deleteSelectedItems = () => {
        props.deleteItems(selectedItems.map(x => x.id), () => {
            messageModal.current.close();
            setSelectedItems([]);
            search();
        });
    }


    const exportCsv = () => {
        props.exportCsv(filter, (data) => {
            downloadFile(data, `Embalagem_${Date.now()}.csv`, "data:text/csv", false);
        })
    }

    const configColumn = () => {
        const cols = [
            {
                field: 'id',
                header: "Id",
                align: 'left',
                sortable: false
            },
            {
                field: 'code',
                header: 'Embalagem',
                align: 'left',
                sortable: false
            },
            {
                field: 'description',
                header: "Descrição",
                body: (rowData) => {
                    if (rowData.id === selectedItem?.id) {
                        return <Input
                            id="description"
                            name='description'
                            label='Descrição'
                            type="text"
                            maxLength="40"
                            required
                            value={selectedItem?.description || ''}
                            onChange={onChangeItem}
                        />

                    }
                    return rowData.description
                },
                align: 'left',
                sortable: false
            },
            {
                field: 'height',
                header: "Altura",
                body: (rowData) => {
                    if (rowData.id === selectedItem?.id) {
                        return <Input
                            id="height"
                            name='height'
                            label='Altura'
                            type="number"
                            value={selectedItem?.height || ''}
                            onChange={onChangeItem}

                        />
                    }
                    return rowData.height
                },
                align: 'left',
                sortable: false
            },
            {
                field: 'width',
                header: "Largura",
                body: (rowData) => {
                    if (rowData.id === selectedItem?.id) {
                        return <Input
                            id="width"
                            name='width'
                            label='Largura'
                            type="number"
                            value={selectedItem?.width || ''}
                            onChange={onChangeItem}

                        />
                    }
                    return rowData.width
                },
                align: 'left',
                sortable: false
            },
            {
                field: 'length',
                header: "Comprimento",
                body: (rowData) => {
                    if (rowData.id === selectedItem?.id) {
                        return <Input
                            id="length"
                            name='length'
                            label='Comprimento'
                            type="number"
                            value={selectedItem?.length || ''}
                            onChange={onChangeItem}

                        />
                    }
                    return rowData.length
                },
                align: 'left',
                sortable: false
            },
            {
                field: 'volume',
                header: "Volume",
                body: (rowData) => {
                    if (rowData.id === selectedItem?.id) {
                        return <Input
                            id="volume"
                            name='volume'
                            label='Volume'
                            type="number"
                            disabled
                            value={selectedItem?.volume || ''}
                            onChange={onChangeItem}

                        />
                    }
                    return rowData.volume
                },
                align: 'left',
                sortable: false
            },
            {
                field: 'weight',
                header: "Peso",
                body: (rowData) => {
                    if (rowData.id === selectedItem?.id) {
                        return <CustomNumberInput
                            id={`weight${rowData.id}`}
                            name='weight'
                            label='Peso'
                            required
                            value={selectedItem?.weight || ''}
                            onChange={onChangeItemWeight}
                        />
                    }
                    return rowData.weight
                },
                align: 'left',
                sortable: false
            },
            {
                field: 'createdOn',
                body: (rowData) => formatDateToPtbr(rowData.createdOn),
                header: 'Data Criação',
                align: 'left',
                sortable: false
            },
            {
                field: 'createdBy',
                header: 'Criado Por',
                body: (rowData) => getUserNameToName(props?.usersFromElog, rowData.updatedBy || rowData.createdBy),
                align: 'left',
            }
        ];
        return cols;
    };

    const configActions = () => [
        {
            function: (row) => (
                <i className="material-icons sixth-text-color"
                    onClick={() => {
                        if (selectedItem?.id === row.id) {
                            props.updateMdr(selectedItem, () => {
                                setSelectedItem(undefined);
                                search()
                            })
                        } else {
                            onSelectChange(row)
                        }
                    }}
                    style={{ fontSize: '1.85rem', cursor: 'pointer', color: 'green' }}>
                    {selectedItem?.id === row.id ? 'save' : 'edit'}</i>
            )
        },
        {
            function: (row) => (
                <i className="material-icons sixth-text-color"
                    onClick={() => openModal(row.id)}
                    style={{ fontSize: '1.85rem', cursor: 'pointer', color: 'red' }}>delete</i>
            )
        }, {
            function: (row) => (
                <Input
                    type="checkbox"
                    onChange={() => onCheckedChange(row)}
                    id="select"
                    name="select"
                    checked={selectedItems.find(f => f.id === row.id) || false}
                />
            )
        },
    ];

    return (
        <div>
            <Breadcrumbs
                title={{ icon: "mdi mdi-view-dashboard-outline", label: 'Embalagens' }} />
            { 
                checkPermission(PERMISSIONS.Warehouse_Container.Config.MDR) &&
                <i className={`mdi mdi-36px mdi-sticker-plus above-btn`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => props.history.push({ pathname: './insert' })} />
            }
            <i className={`mdi mdi-36px mdi-file-excel above-btn`}
                style={{ cursor: 'pointer' }}
                onClick={() => exportCsv()} />
            <div className="container-fluid" style={{ marginTop: '30px' }}>
                <div className="container" style={{ marginTop: '0px', }}>
                    <Collapsible
                        id="filterSection"
                        header={translate('general:filters')}
                        body={
                            <>
                                <form id="getReport" className="col s12">
                                    <div className="row" style={{ padding: '10px' }}>
                                        <div className="input-field no-padding outlined col s4">
                                            <Input
                                                id="code"
                                                name='code'
                                                label='Embalagem'
                                                type="text"
                                                maxLength="5"
                                                value={filter?.code || ''}
                                                onChange={onChange}
                                            />
                                        </div>
                                        <div className="input-field no-padding outlined col s5">
                                            <Input
                                                id="description"
                                                name='description'
                                                label='Descrição'
                                                type="text"
                                                maxLength="40"

                                                value={filter?.description || ''}
                                                onChange={onChange}

                                            />
                                        </div>
                                    </div>
                                </form>
                                <div className="row" style={{ paddingTop: '5px' }}>
                                    <Button full="true" text={translate("general:search")} onClick={search} />
                                </div>
                            </>
                        }
                    />
                </div>
                {selectedItems.length > 0 &&
                    <div className="row" style={{ paddingTop: 5, marginLeft: 20, marginRight: 20 }}>
                        <Button full="true" text="Excluir Selecionados" onClick={() => { setDeleteAllSelected(true); messageModal.current.show() }} />
                    </div>
                }
                <Table
                    totalPages={mdrList.length / currentPage.pageSize}
                    current={{ currentPage, setCurrentPage }}
                    col={configColumn()}
                    data={mdrList}
                    actions={configActions()} />
            </div>
            <ConfirmModal
                ref={messageModal}
                id="messageModalDelete"
                data={{ title: translate('validations:attention'), message: translate("token.confirmation-delete", "configuration") }}
                onConfirm={() => {
                    if (deleteAllSelected) {
                        deleteSelectedItems();
                        setDeleteAllSelected(true);
                    } else {
                        deleteSelectedItem();
                    }
                }}
                btnCancel={translate('cancel', 'general')}
                btnConfirm={translate('confirm', 'general')}
            />
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        usersFromElog: state.usersElogReducer.usersElog,
        user: state.userReducer.user,
        mdrList: state.containerReducer.mdrList
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getMdrPaged: (filter) => {
            dispatch(ContainerService.getMdrPaged(filter));
        },
        setMdr: (item) => {
            dispatch(containerAction.setMdr(item));
        },
        deleteItem: (id, callback) => {
            dispatch(ContainerService.deleteMdr([id], callback));
        },
        deleteItems: (ids, callback) => {
            dispatch(ContainerService.deleteMdr(ids, callback));
        },
        updateMdr: (model, callback) => {
            dispatch(ContainerService.updateMdr(model, callback));
        },
        exportCsv: (filter, callback) => {
            dispatch(ContainerService.exportMdrCsv(filter, callback));
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Mdr));
